import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"
import { CheckCircle2, AlertTriangle, Info } from "lucide-react"
import { cn } from "@/lib/utils"

const VARIANT_ICON = {
  success: { Icon: CheckCircle2, color: "text-green-500" },
  destructive: { Icon: AlertTriangle, color: "text-red-500" },
  warning: { Icon: Info, color: "text-amber-500" },
  info: { Icon: Info, color: "text-blue-500" },
} as const

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        const meta =
          variant && variant !== "default"
            ? VARIANT_ICON[variant as keyof typeof VARIANT_ICON]
            : VARIANT_ICON.info

        return (
          <Toast key={id} variant={variant} {...props}>
            <div className={cn('flex gap-3', description ? 'items-start' : 'items-center')}>
              {meta && (
                <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white shadow-sm">
                  <meta.Icon className={cn("h-5 w-5", meta.color)} />
                </span>
              )}
              <div className="grid gap-1">
                {title && <ToastTitle className="text-gray-900">{title}</ToastTitle>}
                {description && (
                  <ToastDescription className="text-gray-500">
                    {description}
                  </ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
